export function downloadFile(blob: Blob, filename: string): void {
  if (!blob) return;

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');

  try {
    a.href = url;
    a.download = filename || 'download';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
  } finally {
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}

export function getExtensionFromMime(mime: string): string {
  const map: Record<string, string> = {
    'application/pdf': 'pdf',
    'application/zip': 'zip',
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  };
  return map[mime] || 'bin';
}
